// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/webhook.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { Subject } from "./identity_pb.js";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { Workflow } from "./workflow_pb.js";

/**
 * WebhookType determines the scope level of the webhook.
 *
 * @generated from enum gitpod.v1.WebhookType
 */
export enum WebhookType {
  /**
   * @generated from enum value: WEBHOOK_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Scoped to a specific repository (e.g., "owner/repo")
   *
   * @generated from enum value: WEBHOOK_TYPE_SCM_REPOSITORY = 1;
   */
  SCM_REPOSITORY = 1,

  /**
   * Scoped to an organization (e.g., "owner" - all repos)
   *
   * @generated from enum value: WEBHOOK_TYPE_SCM_ORGANIZATION = 2;
   */
  SCM_ORGANIZATION = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(WebhookType)
proto3.util.setEnumType(WebhookType, "gitpod.v1.WebhookType", [
  { no: 0, name: "WEBHOOK_TYPE_UNSPECIFIED" },
  { no: 1, name: "WEBHOOK_TYPE_SCM_REPOSITORY" },
  { no: 2, name: "WEBHOOK_TYPE_SCM_ORGANIZATION" },
]);

/**
 * WebhookProvider identifies the Git provider.
 *
 * @generated from enum gitpod.v1.WebhookProvider
 */
export enum WebhookProvider {
  /**
   * @generated from enum value: WEBHOOK_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WEBHOOK_PROVIDER_GITHUB = 1;
   */
  GITHUB = 1,

  /**
   * @generated from enum value: WEBHOOK_PROVIDER_GITLAB = 2;
   */
  GITLAB = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(WebhookProvider)
proto3.util.setEnumType(WebhookProvider, "gitpod.v1.WebhookProvider", [
  { no: 0, name: "WEBHOOK_PROVIDER_UNSPECIFIED" },
  { no: 1, name: "WEBHOOK_PROVIDER_GITHUB" },
  { no: 2, name: "WEBHOOK_PROVIDER_GITLAB" },
]);

/**
 * WebhookRepositoryScope represents a repository in the webhook's scope.
 * Contains SCM repository information needed to generate execution contexts.
 * The clone URL can be derived as https://{host}/{owner}/{name}.git
 *
 * @generated from message gitpod.v1.WebhookRepositoryScope
 */
export class WebhookRepositoryScope extends Message<WebhookRepositoryScope> {
  /**
   * host is the SCM host (e.g., "github.com", "gitlab.com")
   *
   * @generated from field: string host = 2;
   */
  host = "";

  /**
   * owner is the repository owner or organization (e.g., "gitpod-io")
   *
   * @generated from field: string owner = 3;
   */
  owner = "";

  /**
   * name is the repository name (e.g., "gitpod")
   *
   * @generated from field: string name = 4;
   */
  name = "";

  constructor(data?: PartialMessage<WebhookRepositoryScope>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WebhookRepositoryScope";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WebhookRepositoryScope {
    return new WebhookRepositoryScope().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WebhookRepositoryScope {
    return new WebhookRepositoryScope().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WebhookRepositoryScope {
    return new WebhookRepositoryScope().fromJsonString(jsonString, options);
  }

  static equals(a: WebhookRepositoryScope | PlainMessage<WebhookRepositoryScope> | undefined, b: WebhookRepositoryScope | PlainMessage<WebhookRepositoryScope> | undefined): boolean {
    return proto3.util.equals(WebhookRepositoryScope, a, b);
  }
}

/**
 * WebhookOrganizationScope represents an SCM organization in the webhook's scope.
 *
 * @generated from message gitpod.v1.WebhookOrganizationScope
 */
export class WebhookOrganizationScope extends Message<WebhookOrganizationScope> {
  /**
   * host is the SCM host (e.g., "github.com", "gitlab.com")
   *
   * @generated from field: string host = 1;
   */
  host = "";

  /**
   * name is the organization or group name (e.g., "gitpod-io")
   *
   * @generated from field: string name = 2;
   */
  name = "";

  constructor(data?: PartialMessage<WebhookOrganizationScope>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WebhookOrganizationScope";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WebhookOrganizationScope {
    return new WebhookOrganizationScope().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WebhookOrganizationScope {
    return new WebhookOrganizationScope().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WebhookOrganizationScope {
    return new WebhookOrganizationScope().fromJsonString(jsonString, options);
  }

  static equals(a: WebhookOrganizationScope | PlainMessage<WebhookOrganizationScope> | undefined, b: WebhookOrganizationScope | PlainMessage<WebhookOrganizationScope> | undefined): boolean {
    return proto3.util.equals(WebhookOrganizationScope, a, b);
  }
}

/**
 * Webhook represents a webhook endpoint for receiving SCM events.
 *
 * @generated from message gitpod.v1.Webhook
 */
export class Webhook extends Message<Webhook> {
  /**
   * id is the unique identifier of the webhook
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * metadata contains organizational and ownership information
   *
   * @generated from field: gitpod.v1.Webhook.Metadata metadata = 2;
   */
  metadata?: Webhook_Metadata;

  /**
   * spec contains the webhook configuration
   *
   * @generated from field: gitpod.v1.Webhook.Spec spec = 3;
   */
  spec?: Webhook_Spec;

  /**
   * url is the generated webhook endpoint URL
   * Format: https://{domain}/webhooks/{id}
   * Read-only, computed from id
   *
   * @generated from field: string url = 4;
   */
  url = "";

  /**
   * bound_workflow_count is the number of workflows bound to this webhook
   * Read-only, computed from workflow_webhook_bindings
   *
   * @generated from field: int32 bound_workflow_count = 5;
   */
  boundWorkflowCount = 0;

  /**
   * last_triggered_at is when the webhook was last triggered by an incoming event
   * Read-only, updated automatically when the webhook receives an event
   *
   * @generated from field: google.protobuf.Timestamp last_triggered_at = 6;
   */
  lastTriggeredAt?: Timestamp;

  constructor(data?: PartialMessage<Webhook>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Webhook";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: Webhook_Metadata },
    { no: 3, name: "spec", kind: "message", T: Webhook_Spec },
    { no: 4, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "bound_workflow_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "last_triggered_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Webhook {
    return new Webhook().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Webhook {
    return new Webhook().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Webhook {
    return new Webhook().fromJsonString(jsonString, options);
  }

  static equals(a: Webhook | PlainMessage<Webhook> | undefined, b: Webhook | PlainMessage<Webhook> | undefined): boolean {
    return proto3.util.equals(Webhook, a, b);
  }
}

/**
 * Metadata contains organizational and ownership information.
 *
 * @generated from message gitpod.v1.Webhook.Metadata
 */
export class Webhook_Metadata extends Message<Webhook_Metadata> {
  /**
   * organization_id is the ID of the organization that owns this webhook
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * name is the display name of the webhook
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * description is an optional description of the webhook's purpose
   *
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * creator is the identity of who created the webhook
   *
   * @generated from field: gitpod.v1.Subject creator = 4;
   */
  creator?: Subject;

  /**
   * created_at is when the webhook was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the webhook was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<Webhook_Metadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Webhook.Metadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "creator", kind: "message", T: Subject },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Webhook_Metadata {
    return new Webhook_Metadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Webhook_Metadata {
    return new Webhook_Metadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Webhook_Metadata {
    return new Webhook_Metadata().fromJsonString(jsonString, options);
  }

  static equals(a: Webhook_Metadata | PlainMessage<Webhook_Metadata> | undefined, b: Webhook_Metadata | PlainMessage<Webhook_Metadata> | undefined): boolean {
    return proto3.util.equals(Webhook_Metadata, a, b);
  }
}

/**
 * Spec contains the webhook configuration.
 *
 * @generated from message gitpod.v1.Webhook.Spec
 */
export class Webhook_Spec extends Message<Webhook_Spec> {
  /**
   * type determines the scope level of the webhook
   *
   * @generated from field: gitpod.v1.WebhookType type = 1;
   */
  type = WebhookType.UNSPECIFIED;

  /**
   * Deprecated: Use scopes instead. Kept for backward compatibility.
   * scope is the target of the webhook:
   * - For REPOSITORY type: "owner/repo" (e.g., "gitpod-io/gitpod")
   * - For ORGANIZATION type: "owner" (e.g., "gitpod-io")
   *
   * @generated from field: string scope = 2 [deprecated = true];
   * @deprecated
   */
  scope = "";

  /**
   * provider is the Git provider (github, gitlab)
   *
   * @generated from field: gitpod.v1.WebhookProvider provider = 3;
   */
  provider = WebhookProvider.UNSPECIFIED;

  /**
   * scopes is the list of repository scopes for this webhook.
   * For REPOSITORY type: each entry represents a specific repository.
   * When scopes is non-empty, it takes precedence over the deprecated scope field.
   *
   * @generated from field: repeated gitpod.v1.WebhookRepositoryScope scopes = 4;
   */
  scopes: WebhookRepositoryScope[] = [];

  /**
   * organization_scope is the SCM organization scope for this webhook.
   * For ORGANIZATION type: identifies the organization and its SCM host.
   * When set, takes precedence over the deprecated scope field.
   *
   * @generated from field: gitpod.v1.WebhookOrganizationScope organization_scope = 5;
   */
  organizationScope?: WebhookOrganizationScope;

  constructor(data?: PartialMessage<Webhook_Spec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Webhook.Spec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(WebhookType) },
    { no: 2, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "provider", kind: "enum", T: proto3.getEnumType(WebhookProvider) },
    { no: 4, name: "scopes", kind: "message", T: WebhookRepositoryScope, repeated: true },
    { no: 5, name: "organization_scope", kind: "message", T: WebhookOrganizationScope },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Webhook_Spec {
    return new Webhook_Spec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Webhook_Spec {
    return new Webhook_Spec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Webhook_Spec {
    return new Webhook_Spec().fromJsonString(jsonString, options);
  }

  static equals(a: Webhook_Spec | PlainMessage<Webhook_Spec> | undefined, b: Webhook_Spec | PlainMessage<Webhook_Spec> | undefined): boolean {
    return proto3.util.equals(Webhook_Spec, a, b);
  }
}

/**
 * CreateWebhookRequest creates a new webhook.
 *
 * @generated from message gitpod.v1.CreateWebhookRequest
 */
export class CreateWebhookRequest extends Message<CreateWebhookRequest> {
  /**
   * name is the display name of the webhook
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * description is an optional description of the webhook's purpose
   *
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * type determines the scope level of the webhook
   *
   * @generated from field: gitpod.v1.WebhookType type = 3;
   */
  type = WebhookType.UNSPECIFIED;

  /**
   * Deprecated: Use scopes instead.
   * scope is the target of the webhook:
   * - For REPOSITORY type: "owner/repo" (e.g., "gitpod-io/gitpod")
   * - For ORGANIZATION type: "owner" (e.g., "gitpod-io")
   * - Empty string is allowed for webhooks that don't require scope filtering
   *
   * @generated from field: string scope = 4 [deprecated = true];
   * @deprecated
   */
  scope = "";

  /**
   * provider is the Git provider
   *
   * @generated from field: gitpod.v1.WebhookProvider provider = 5;
   */
  provider = WebhookProvider.UNSPECIFIED;

  /**
   * scopes is the list of repository scopes for this webhook.
   * For REPOSITORY type: each entry represents a specific repository with full SCM data.
   * When provided, takes precedence over the deprecated scope field.
   *
   * @generated from field: repeated gitpod.v1.WebhookRepositoryScope scopes = 6;
   */
  scopes: WebhookRepositoryScope[] = [];

  /**
   * organization_scope is the SCM organization scope for this webhook.
   * For ORGANIZATION type: identifies the organization and its SCM host.
   * When provided, takes precedence over the deprecated scope field.
   *
   * @generated from field: gitpod.v1.WebhookOrganizationScope organization_scope = 7;
   */
  organizationScope?: WebhookOrganizationScope;

  constructor(data?: PartialMessage<CreateWebhookRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateWebhookRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(WebhookType) },
    { no: 4, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "provider", kind: "enum", T: proto3.getEnumType(WebhookProvider) },
    { no: 6, name: "scopes", kind: "message", T: WebhookRepositoryScope, repeated: true },
    { no: 7, name: "organization_scope", kind: "message", T: WebhookOrganizationScope },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWebhookRequest {
    return new CreateWebhookRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWebhookRequest {
    return new CreateWebhookRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWebhookRequest {
    return new CreateWebhookRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWebhookRequest | PlainMessage<CreateWebhookRequest> | undefined, b: CreateWebhookRequest | PlainMessage<CreateWebhookRequest> | undefined): boolean {
    return proto3.util.equals(CreateWebhookRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateWebhookResponse
 */
export class CreateWebhookResponse extends Message<CreateWebhookResponse> {
  /**
   * @generated from field: gitpod.v1.Webhook webhook = 1;
   */
  webhook?: Webhook;

  constructor(data?: PartialMessage<CreateWebhookResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateWebhookResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook", kind: "message", T: Webhook },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWebhookResponse {
    return new CreateWebhookResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWebhookResponse {
    return new CreateWebhookResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWebhookResponse {
    return new CreateWebhookResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWebhookResponse | PlainMessage<CreateWebhookResponse> | undefined, b: CreateWebhookResponse | PlainMessage<CreateWebhookResponse> | undefined): boolean {
    return proto3.util.equals(CreateWebhookResponse, a, b);
  }
}

/**
 * GetWebhookRequest gets details about a specific webhook.
 *
 * @generated from message gitpod.v1.GetWebhookRequest
 */
export class GetWebhookRequest extends Message<GetWebhookRequest> {
  /**
   * @generated from field: string webhook_id = 1;
   */
  webhookId = "";

  constructor(data?: PartialMessage<GetWebhookRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWebhookRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWebhookRequest {
    return new GetWebhookRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWebhookRequest {
    return new GetWebhookRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWebhookRequest {
    return new GetWebhookRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetWebhookRequest | PlainMessage<GetWebhookRequest> | undefined, b: GetWebhookRequest | PlainMessage<GetWebhookRequest> | undefined): boolean {
    return proto3.util.equals(GetWebhookRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetWebhookResponse
 */
export class GetWebhookResponse extends Message<GetWebhookResponse> {
  /**
   * @generated from field: gitpod.v1.Webhook webhook = 1;
   */
  webhook?: Webhook;

  constructor(data?: PartialMessage<GetWebhookResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWebhookResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook", kind: "message", T: Webhook },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWebhookResponse {
    return new GetWebhookResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWebhookResponse {
    return new GetWebhookResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWebhookResponse {
    return new GetWebhookResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetWebhookResponse | PlainMessage<GetWebhookResponse> | undefined, b: GetWebhookResponse | PlainMessage<GetWebhookResponse> | undefined): boolean {
    return proto3.util.equals(GetWebhookResponse, a, b);
  }
}

/**
 * ListWebhooksRequest lists webhooks with optional filtering.
 *
 * @generated from message gitpod.v1.ListWebhooksRequest
 */
export class ListWebhooksRequest extends Message<ListWebhooksRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListWebhooksRequest.Filter filter = 2;
   */
  filter?: ListWebhooksRequest_Filter;

  constructor(data?: PartialMessage<ListWebhooksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWebhooksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListWebhooksRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWebhooksRequest {
    return new ListWebhooksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWebhooksRequest {
    return new ListWebhooksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWebhooksRequest {
    return new ListWebhooksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWebhooksRequest | PlainMessage<ListWebhooksRequest> | undefined, b: ListWebhooksRequest | PlainMessage<ListWebhooksRequest> | undefined): boolean {
    return proto3.util.equals(ListWebhooksRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWebhooksRequest.Filter
 */
export class ListWebhooksRequest_Filter extends Message<ListWebhooksRequest_Filter> {
  /**
   * webhook_ids filters by specific webhook IDs
   *
   * @generated from field: repeated string webhook_ids = 1;
   */
  webhookIds: string[] = [];

  /**
   * types filters by webhook type
   *
   * @generated from field: repeated gitpod.v1.WebhookType types = 2;
   */
  types: WebhookType[] = [];

  /**
   * providers filters by webhook provider
   *
   * @generated from field: repeated gitpod.v1.WebhookProvider providers = 3;
   */
  providers: WebhookProvider[] = [];

  constructor(data?: PartialMessage<ListWebhooksRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWebhooksRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "types", kind: "enum", T: proto3.getEnumType(WebhookType), repeated: true },
    { no: 3, name: "providers", kind: "enum", T: proto3.getEnumType(WebhookProvider), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWebhooksRequest_Filter {
    return new ListWebhooksRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWebhooksRequest_Filter {
    return new ListWebhooksRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWebhooksRequest_Filter {
    return new ListWebhooksRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListWebhooksRequest_Filter | PlainMessage<ListWebhooksRequest_Filter> | undefined, b: ListWebhooksRequest_Filter | PlainMessage<ListWebhooksRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListWebhooksRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWebhooksResponse
 */
export class ListWebhooksResponse extends Message<ListWebhooksResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Webhook webhooks = 2;
   */
  webhooks: Webhook[] = [];

  constructor(data?: PartialMessage<ListWebhooksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWebhooksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "webhooks", kind: "message", T: Webhook, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWebhooksResponse {
    return new ListWebhooksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWebhooksResponse {
    return new ListWebhooksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWebhooksResponse {
    return new ListWebhooksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWebhooksResponse | PlainMessage<ListWebhooksResponse> | undefined, b: ListWebhooksResponse | PlainMessage<ListWebhooksResponse> | undefined): boolean {
    return proto3.util.equals(ListWebhooksResponse, a, b);
  }
}

/**
 * UpdateWebhookRequest updates a webhook's configuration.
 *
 * @generated from message gitpod.v1.UpdateWebhookRequest
 */
export class UpdateWebhookRequest extends Message<UpdateWebhookRequest> {
  /**
   * @generated from field: string webhook_id = 1;
   */
  webhookId = "";

  /**
   * name is the display name of the webhook
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * description is an optional description of the webhook's purpose
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * Deprecated: Use scopes instead.
   * scope is the target of the webhook:
   * - For REPOSITORY type: "owner/repo" (e.g., "gitpod-io/gitpod")
   * - For ORGANIZATION type: "owner" (e.g., "gitpod-io")
   * Note: The webhook type and provider cannot be changed after creation.
   *
   * @generated from field: optional string scope = 4 [deprecated = true];
   * @deprecated
   */
  scope?: string;

  /**
   * scopes replaces the webhook's repository scopes.
   * For REPOSITORY type: each entry represents a specific repository with full SCM data.
   * When provided, takes precedence over the deprecated scope field.
   * Note: The webhook type and provider cannot be changed after creation.
   *
   * @generated from field: repeated gitpod.v1.WebhookRepositoryScope scopes = 5;
   */
  scopes: WebhookRepositoryScope[] = [];

  /**
   * organization_scope replaces the webhook's organization scope.
   * For ORGANIZATION type: identifies the organization and its SCM host.
   * When provided, takes precedence over the deprecated scope field.
   * Note: The webhook type and provider cannot be changed after creation.
   *
   * @generated from field: gitpod.v1.WebhookOrganizationScope organization_scope = 6;
   */
  organizationScope?: WebhookOrganizationScope;

  constructor(data?: PartialMessage<UpdateWebhookRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateWebhookRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "scopes", kind: "message", T: WebhookRepositoryScope, repeated: true },
    { no: 6, name: "organization_scope", kind: "message", T: WebhookOrganizationScope },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWebhookRequest {
    return new UpdateWebhookRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWebhookRequest {
    return new UpdateWebhookRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWebhookRequest {
    return new UpdateWebhookRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWebhookRequest | PlainMessage<UpdateWebhookRequest> | undefined, b: UpdateWebhookRequest | PlainMessage<UpdateWebhookRequest> | undefined): boolean {
    return proto3.util.equals(UpdateWebhookRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateWebhookResponse
 */
export class UpdateWebhookResponse extends Message<UpdateWebhookResponse> {
  /**
   * @generated from field: gitpod.v1.Webhook webhook = 1;
   */
  webhook?: Webhook;

  constructor(data?: PartialMessage<UpdateWebhookResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateWebhookResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook", kind: "message", T: Webhook },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWebhookResponse {
    return new UpdateWebhookResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWebhookResponse {
    return new UpdateWebhookResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWebhookResponse {
    return new UpdateWebhookResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWebhookResponse | PlainMessage<UpdateWebhookResponse> | undefined, b: UpdateWebhookResponse | PlainMessage<UpdateWebhookResponse> | undefined): boolean {
    return proto3.util.equals(UpdateWebhookResponse, a, b);
  }
}

/**
 * DeleteWebhookRequest deletes a webhook permanently.
 *
 * @generated from message gitpod.v1.DeleteWebhookRequest
 */
export class DeleteWebhookRequest extends Message<DeleteWebhookRequest> {
  /**
   * @generated from field: string webhook_id = 1;
   */
  webhookId = "";

  constructor(data?: PartialMessage<DeleteWebhookRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteWebhookRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteWebhookRequest {
    return new DeleteWebhookRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteWebhookRequest {
    return new DeleteWebhookRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteWebhookRequest {
    return new DeleteWebhookRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteWebhookRequest | PlainMessage<DeleteWebhookRequest> | undefined, b: DeleteWebhookRequest | PlainMessage<DeleteWebhookRequest> | undefined): boolean {
    return proto3.util.equals(DeleteWebhookRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteWebhookResponse
 */
export class DeleteWebhookResponse extends Message<DeleteWebhookResponse> {
  /**
   * IDs of workflows that had their triggers converted to manual type
   * because they referenced the deleted webhook.
   *
   * @generated from field: repeated string affected_workflow_ids = 1;
   */
  affectedWorkflowIds: string[] = [];

  constructor(data?: PartialMessage<DeleteWebhookResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteWebhookResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "affected_workflow_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteWebhookResponse {
    return new DeleteWebhookResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteWebhookResponse {
    return new DeleteWebhookResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteWebhookResponse {
    return new DeleteWebhookResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteWebhookResponse | PlainMessage<DeleteWebhookResponse> | undefined, b: DeleteWebhookResponse | PlainMessage<DeleteWebhookResponse> | undefined): boolean {
    return proto3.util.equals(DeleteWebhookResponse, a, b);
  }
}

/**
 * GetWebhookSecretRequest retrieves the webhook secret.
 *
 * @generated from message gitpod.v1.GetWebhookSecretRequest
 */
export class GetWebhookSecretRequest extends Message<GetWebhookSecretRequest> {
  /**
   * @generated from field: string webhook_id = 1;
   */
  webhookId = "";

  constructor(data?: PartialMessage<GetWebhookSecretRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWebhookSecretRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWebhookSecretRequest {
    return new GetWebhookSecretRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWebhookSecretRequest {
    return new GetWebhookSecretRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWebhookSecretRequest {
    return new GetWebhookSecretRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetWebhookSecretRequest | PlainMessage<GetWebhookSecretRequest> | undefined, b: GetWebhookSecretRequest | PlainMessage<GetWebhookSecretRequest> | undefined): boolean {
    return proto3.util.equals(GetWebhookSecretRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetWebhookSecretResponse
 */
export class GetWebhookSecretResponse extends Message<GetWebhookSecretResponse> {
  /**
   * The decrypted webhook secret
   *
   * @generated from field: string secret = 1;
   */
  secret = "";

  constructor(data?: PartialMessage<GetWebhookSecretResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWebhookSecretResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWebhookSecretResponse {
    return new GetWebhookSecretResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWebhookSecretResponse {
    return new GetWebhookSecretResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWebhookSecretResponse {
    return new GetWebhookSecretResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetWebhookSecretResponse | PlainMessage<GetWebhookSecretResponse> | undefined, b: GetWebhookSecretResponse | PlainMessage<GetWebhookSecretResponse> | undefined): boolean {
    return proto3.util.equals(GetWebhookSecretResponse, a, b);
  }
}

/**
 * RotateWebhookSecretRequest rotates the webhook secret.
 *
 * @generated from message gitpod.v1.RotateWebhookSecretRequest
 */
export class RotateWebhookSecretRequest extends Message<RotateWebhookSecretRequest> {
  /**
   * @generated from field: string webhook_id = 1;
   */
  webhookId = "";

  constructor(data?: PartialMessage<RotateWebhookSecretRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RotateWebhookSecretRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RotateWebhookSecretRequest {
    return new RotateWebhookSecretRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RotateWebhookSecretRequest {
    return new RotateWebhookSecretRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RotateWebhookSecretRequest {
    return new RotateWebhookSecretRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RotateWebhookSecretRequest | PlainMessage<RotateWebhookSecretRequest> | undefined, b: RotateWebhookSecretRequest | PlainMessage<RotateWebhookSecretRequest> | undefined): boolean {
    return proto3.util.equals(RotateWebhookSecretRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RotateWebhookSecretResponse
 */
export class RotateWebhookSecretResponse extends Message<RotateWebhookSecretResponse> {
  /**
   * The new webhook secret (decrypted)
   *
   * @generated from field: string secret = 1;
   */
  secret = "";

  constructor(data?: PartialMessage<RotateWebhookSecretResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RotateWebhookSecretResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RotateWebhookSecretResponse {
    return new RotateWebhookSecretResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RotateWebhookSecretResponse {
    return new RotateWebhookSecretResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RotateWebhookSecretResponse {
    return new RotateWebhookSecretResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RotateWebhookSecretResponse | PlainMessage<RotateWebhookSecretResponse> | undefined, b: RotateWebhookSecretResponse | PlainMessage<RotateWebhookSecretResponse> | undefined): boolean {
    return proto3.util.equals(RotateWebhookSecretResponse, a, b);
  }
}

/**
 * ListWebhookWorkflowsRequest lists workflows bound to a webhook.
 *
 * @generated from message gitpod.v1.ListWebhookWorkflowsRequest
 */
export class ListWebhookWorkflowsRequest extends Message<ListWebhookWorkflowsRequest> {
  /**
   * @generated from field: string webhook_id = 1;
   */
  webhookId = "";

  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListWebhookWorkflowsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWebhookWorkflowsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWebhookWorkflowsRequest {
    return new ListWebhookWorkflowsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWebhookWorkflowsRequest {
    return new ListWebhookWorkflowsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWebhookWorkflowsRequest {
    return new ListWebhookWorkflowsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWebhookWorkflowsRequest | PlainMessage<ListWebhookWorkflowsRequest> | undefined, b: ListWebhookWorkflowsRequest | PlainMessage<ListWebhookWorkflowsRequest> | undefined): boolean {
    return proto3.util.equals(ListWebhookWorkflowsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWebhookWorkflowsResponse
 */
export class ListWebhookWorkflowsResponse extends Message<ListWebhookWorkflowsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Workflow workflows = 2;
   */
  workflows: Workflow[] = [];

  constructor(data?: PartialMessage<ListWebhookWorkflowsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWebhookWorkflowsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "workflows", kind: "message", T: Workflow, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWebhookWorkflowsResponse {
    return new ListWebhookWorkflowsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWebhookWorkflowsResponse {
    return new ListWebhookWorkflowsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWebhookWorkflowsResponse {
    return new ListWebhookWorkflowsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWebhookWorkflowsResponse | PlainMessage<ListWebhookWorkflowsResponse> | undefined, b: ListWebhookWorkflowsResponse | PlainMessage<ListWebhookWorkflowsResponse> | undefined): boolean {
    return proto3.util.equals(ListWebhookWorkflowsResponse, a, b);
  }
}

